import React, { FC } from 'react'
import { ChevronDownIcon } from '@heroicons/react/outline'
import { StyledDraftDrawerSelectors } from '.'
import useDraft from '../../../redux/draft-drawer/useDraft'
import { CAPTION_CATEGORY_LIST } from '../../../types'
import { DraftCategoryType } from '../../../redux/draft-drawer/types'

const DraftDrawerSelectors: FC = () => {
  const {
    category,
    actions: { setDraftCategory }
  } = useDraft()

  return (
    <StyledDraftDrawerSelectors>
      <div className="draft-drawer-category-dropdown">
        <select
          value={category || undefined}
          onChange={(e) => setDraftCategory(e.target.value as DraftCategoryType)}
        >
          <option value="Uncategorized">Uncategorized</option>
          {CAPTION_CATEGORY_LIST.map((label) => {
            return (
              <option value={label} key={label}>
                {label}
              </option>
            )
          })}
        </select>
        <ChevronDownIcon />
      </div>
    </StyledDraftDrawerSelectors>
  )
}

export default DraftDrawerSelectors
